<template>
  <div class="term">
    <h2>{{$route.query.name}}</h2>
	<el-form :inline="true" :model="searchValue" ref="searchValue"  class="demo-ruleForm display-flex" :class="{flex:isFlex}" >
	    <el-form-item label="关键词" prop="keyword">
	      <el-input v-model="searchValue.keyword" placeholder="请输入关键词" @keyup.enter.native="submitForm('searchValue')"></el-input>
	    </el-form-item>
	    <el-form-item class="search-2">
	      <el-button type="primary" @click="submitForm('searchValue')">搜索</el-button>
	      <el-button @click="resetForm('searchValue')">重置</el-button>
	    </el-form-item>
	</el-form>
  <el-table
  class="pc-show"
  :header-cell-style="{background:'rgba(248, 248, 248, 0.39)'}"
  :data="termData"
  border
  stripe
  style="width: 100%">
    <el-table-column
      prop="title"
      label="加工工艺名称（中文）"
      min-width="22%">
    </el-table-column>
    <el-table-column
      prop="title_en"
      label="加工工艺名称（英文）"
      min-width="22%">
    </el-table-column>
    <el-table-column
      prop="definition"
      label="定义"
      min-width="40%">
    </el-table-column>
    <el-table-column
      prop="modifiers"
      label="常用名称/修饰语"
      min-width="16%">
    </el-table-column>
  </el-table>
  <!-- 手机端 -->
  <el-table
  class="moblie-show"
  :header-cell-style="{background:'rgba(248, 248, 248, 0.39)'}"
  :data="termData"
  border
  stripe
  style="width: 100%">
    <el-table-column
      fixed="left"
      prop="title"
      label="加工工艺名称（中文）"
      width="100px">
    </el-table-column>
    <el-table-column
      prop="title_en"
      label="加工工艺名称（英文）"
      width="100px">
    </el-table-column>
    <el-table-column
      prop="definition"
      label="定义"
      width="200px"
      >
    </el-table-column>
    <el-table-column
      prop="modifiers"
      label="常用名称/修饰语"
      width="100px"
      >
    </el-table-column>
  </el-table>
  <div class="block">
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="current_page"
      :page-sizes="[10, 30, 50]"
      :page-size="per_page"
      layout="total, prev, pager, next, sizes, jumper"
      :total="total">
    </el-pagination>
  </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
		searchValue: {
		  keyword:''
		},
        termData: [],
        current_page: 1,
        per_page: 10,
        total: 10,
      isFlex: false,
      }
    },

    methods: {
		submitForm(formName) {
		  this.current_page = 1
		  this.initTermData();
		},
		resetForm(formName) {
		  this.$refs[formName].resetFields();
		  this.initTermData();
		},
      handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
		this.current_page = 1
		this.per_page = val
		this.initTermData();
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.current_page = val;
        this.initTermData();
      },
      initTermData(i){
        this.current_page = i || this.current_page;
        this.$ajax.get('https://api.sy.foodvip.net/?c_key=de5cd2297c84684b&func_name=feed_ngredients_ter',{
          params:{
			keyword:this.searchValue.keyword,
            page:this.current_page,
            num:this.per_page,
          }
        }).then(resp=>{
          if(resp){
            this.termData = resp.data.data.data;
            this.total = resp.data.data.total;
            console.log(resp.data.data.data);
          }
        }).catch(function(error){

        })
      }

    },
    activated() {
    	this.searchValue= {
    	  keyword:''
    	}
		this.initTermData();
    },
    mounted() {
      this.initTermData();
    }
}
</script>

<style scoped>
.term{
  padding-bottom: 40px;
  min-height: auto !important;
}
h2{
  font-size: 16px;
  line-height: 29px;
  color: #1966A7;
  text-align: left;
  font-weight: normal;
}
form.el-form{
  margin-bottom: 20px;
}
@media screen and (max-width:1440px) {
  .flex{
    display: flex;
    flex-wrap: wrap;
    justify-content:space-around;
  }
}
@media screen and (max-width:750px) {
  h2{
    padding: 0;
  }
  .demo-ruleForm.display-flex{
    display: block;
  }
  .demo-ruleForm.display-flex .el-form-item{
    margin-right: 0;
  }
  .el-form-item.moblie-show /deep/ .el-form-item__content{
    width: 100%;
  }
  .search-2 /deep/ .el-form-item__content{
    display: flex;
    justify-content: flex-end;
  }
  .search-2 /deep/ .el-form-item__content button{
    width: 100px;
  }
  .el-form-item.moblie-show /deep/ .el-form-item{
    display: flex;
    justify-content: center;
  }
  .demo-ruleForm.display-flex .search-2{
    display: flex;
    justify-content: flex-end;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/term.vue